import MealTypeSizePrices from '../MealTypeSizePrices/MealTypeSizePrices';

const ShopMealsPrices = () => (
  <MealTypeSizePrices
    priceField="defaultCostForShop"
    descriptionKey="$*priceLists.shopMeals.description"
  />
);

export default ShopMealsPrices;
